import Filter from 'bad-words';

/**
 * Evaluate a string for profanity and return an edited version.
 * @param {text} string - Sentence to filter.
 */
class BadWordsFilter extends Filter {
  //this function can fix the crash w/strings with no word boundaries bug
  cleanWords(text: string) {
    try {
      return this.clean(text);
    } catch {
      //Regular expression used to split a string into words
      const joinMatch = /\b/.exec(text);
      const joinString = (joinMatch && joinMatch[0]) || '';
      return text
        .split(/\b/)
        .map((word: string) => {
          return this.isProfane(word) ? this.replaceWord(word) : word;
        })
        .join(joinString);
    }
  }
}

export const toSeoUrl = (url: string) => {
  if (!url) return null;
  return url
    .toString() // Convert to string
    .normalize('NFD') // Change diacritics
    .replace(/[\u0300-\u036f]/g, '') // Remove illegal characters
    .replace(/\s+/g, '-') // Change whitespace to dashes
    .toLowerCase() // Change to lowercase
    .replace(/[^a-z0-9/-]/g, '') // Remove anything that is not a letter, number or dash
    .replace(/-+/g, '-')
    .replace(/^-*/, '') // Remove starting dashes
    .replace(/-*$/, ''); // Remove trailing dashes
};

export default BadWordsFilter;
